/**
 * 国际化配置文件
 * SC:中文
 * TC:繁体
 */
 export default {
  sysManagement: { SC:"系统管理", TC: "系統管理", EN: "System" },
  update: { SC:"修改", TC: "修改", EN: "Edit" },
  view: { SC:"查看", TC: "查看", EN: "View" },
  delete: { SC:"删除", TC: "刪除", EN: "Delete" },
  audit: { SC:"日志", TC: "日誌", EN: "Log" },
  selectiveData: { SC:"请选择一条数据", TC: "請選擇一條數據", EN: "Please select a reord." },
  deleteData: { SC:"数据删除中...", TC: "數據删除中...", EN: "Data is processing..." },
  deleteSuccess: { SC:"删除成功", TC: "刪除成功", EN: "Deleted successfully." },
  beQuerying: { SC:"查询中...", TC: "査詢中...", EN: "Searching..." },
  noneDate: { SC:"找不到符合条件记录.", TC: "找不到符合條件記錄.", EN: "No record is founed." },
  saveSuccess: { SC:"保存成功", TC: "保存成功", EN: "Saved successfully." },
  controls: { SC:"操作", TC: "操作", EN: "Operation" },
  list: { SC:"列表", TC: "列表", EN: "List" },
  search: { SC:"查询", TC: "査詢", EN: "Search" },
  reset: { SC:"重置", TC: "重置", EN: "Reset" },
  add: { SC:"新增", TC: "新增", EN: "Add" },
  save: { SC:"保存", TC: "保存", EN: "Save" },
  select: { SC:"选择", TC: "選擇", EN: "Select" },
  cancel: { SC:"取消", TC: "取消", EN: "Cancel" },
  dataBeSaving: { SC:"数据保存中...", TC: "數據保存中...", EN: "Data is processing..." },

  notDelete: { SC:"非冻结用戶不能刪除", TC: "非凍結用戶不能删除", EN: "Only inactive user can be deleted." },
  correctPhone: { SC:"请输入正确的手机号", TC: "請輸入正確的手機號", EN: "Please input correct phone." },
  phoneIsNoNull: { SC:"新手机号不能为空", TC: "新手機號不能為空", EN: "Phone is required." },
  saveUser: { SC:"请先保存用戶信息", TC: "請先保存用戶信息", EN: "Please save user information first." },
  userId: { SC:"User ID", TC: "User ID", EN: "User ID" },
  userName: { SC:"用戶名", TC: "用戶名", EN: "User Name" },
  userNameIsNoNull: { SC:"用戶名不能为空", TC: "用戶名不能為空", EN: "User Name is required." },
  phone: { SC:"手机号码", TC: "手機號碼", EN: "Phone" },
  realName: { SC:"真实姓名", TC: "真實姓名", EN: "Real Name" },
  realNameIsNoNull: { SC:"真实姓名不能为空", TC: "真實姓名不能為空", EN: "Real Name is required." },
  docId: { SC:"身份证号", TC: "身份證號", EN: "ID No" },
  docIdIsNoNull: { SC:"身份证号不能为空", TC: "身份證號不能為空", EN: "ID No is required." },
  email: { SC:"邮箱", TC: "郵箱", EN: "Email" },
  activeInd: { SC:"状态", TC: "狀態", EN: "Status" },
  activeIndIsNoNull: { SC:"状态不能为空", TC: "狀態不能為空", EN: "Status is required." },
  bindDocId: { SC:"绑定身份证", TC: "綁定身份證", EN: "Bind ID No" },
  roleName: { SC:"角色名称", TC: "角色名稱", EN: "Role Name" },
  roleNameIsNoNull: { SC:"角色名称不能为空", TC: "角色名稱不能為空", EN: "Role Name is required." },
  roleCode: { SC:"角色编码", TC: "角色編碼", EN: "Role Code" },
  defaultInd: { SC:"登入默认角色", TC: "登入默認角色", EN: "Default Role" },
  defaultIndIsNoNull: { SC:"登入默认角色不能为空", TC: "登入默認角色不能為空", EN: "Default Role is required." },
  jHActiveInd: { SC:"激活状态", TC: "激活狀態", EN: "Active Status" },
  jHActiveIndIsNoNull: { SC:"激活状态不能为空", TC: "激活狀態不能為空", EN: "Active Status is required." },
  user: { SC:"用户", TC: "用戶", EN: "User" },
  lookOut: { SC:"注意：用户ID为系统自动生成", TC: "注意：用戶ID為系統自動生成", EN: "Note: The user id is generated by the system." },
  password: { SC:"密码", TC: "密碼", EN: "Password" },
  passwordIsNoNull: { SC:"密码不能为空", TC: "密碼不能為空", EN: "Password is required." },
  passwordMin: { SC:"密码至少8位", TC: "密碼至少8位", EN: "Password must have at least 8 digits." },
  userType: { SC:"用戶类型", TC: "用戶類型", EN: "User Type" },
  userTypeIsNoNull: { SC:"用戶类型不能为空", TC: "用戶類型不能為空", EN: "User Type is required." },
  role: { SC:"角色", TC: "角色", EN: "Role" },
  userAccount: { SC:"用户账号", TC: "用戶帳號", EN: "Account" },
  addRole: { SC:"角色 新增/修改框", TC: "角色 新增/修改框", EN: "Role Add/Edit" },
  roleCode2: { SC:"角色编号", TC: "角色編號", EN: "Role Code" },

  sysManage: { SC:"系统管理", TC: "系統管理" , EN: "System" },
  errorIDNo: { SC:"请输入正确的身份证号码", TC: "請輸入正確的身份證號碼" , EN: "Please enter the correct ID No." },
  userCode: { SC:"用户账号", TC:"用戶賬號", EN: "User Code" },
  userCodeIsNoNull: { SC:"用户账号不能为空", TC: "用戶賬號不能為空", EN: "User Code is required." },
  incorrectEmailFormat: { SC:"邮箱格式错误", TC:"郵箱格式錯誤", EN: "Incorrect Email format." }

  ,progCode: { SC:"", TC: "", EN: "Programme Code" }
  ,progTitle: { SC:"", TC: "", EN: "Programme Name" }
  ,progLaunchYear: { SC:"", TC: "", EN: "Launch Year" }
  ,deptCode: { SC:"", TC: "", EN: "Department" }
  , pleaseSelectAtLeastOneRecord: { SC: "请选择至少一条数据", TC: "請選擇至少一條數據", EN: "Please select at least one record." }
}